import styled from "styled-components";

export const PlayerWrapper = styled.div<{
  isVertical: boolean;
  isMobile?: boolean;
  aspectRatio?: string;
}>`
  position: relative;
  width: 100%;
  height: auto;
  max-width: 100%;
  aspect-ratio: ${({ aspectRatio, isVertical }) => {
    console.log('aspectRatio', aspectRatio);
    // Prioridad 1: aspectRatio proporcionado directamente
    if (aspectRatio) return aspectRatio;

    // Prioridad 2: fallback a aspect ratios estándar
    return isVertical ? "9/16" : "16/9";
  }};
  margin: 0 auto;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  
  video {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 6px;
    background: #000;
  }
`;


export const OptimizationBanner = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 6px;
  backdrop-filter: blur(2px);
  z-index: 10;
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover > div {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const TooltipText = styled.div`
  position: absolute;
  top: 120%;
  left: -100px;
  background-color: #000;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 11.5px;
  white-space: normal;
  line-height: 1.4;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 20;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
  pointer-events: none;
  width: 200px;
`;

export const DeviceWarning = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgb(255, 140, 0);
  padding: 12px 16px;
  border-radius: 10px;
  font-weight: bold;
  text-align: center;
  z-index: 10;
  max-width: 90%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.25);
  color: #000;
  font-size: 14px;
  line-height: 1.4;

  a {
    color: #000;
    text-decoration: underline;
    display: inline-block;
    margin-top: 6px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 10px 12px;
  }
`;

export const SpeedSelector = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 10;

  select {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 12px;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }
`;
